<div pias-layout-content>
  <div class="onboarding-comments" [formGroup]="commentsForm">
    <div class="comments-container">
      <h5 class="comments-title">Comments</h5>
      <div class="comments-grid">
        @for (field of commentFields; track field.key) {
        <div class="comment-box">
          <mat-label class="field-label">{{ field.label }}</mat-label>
          <mat-form-field class="comment-field">
            <textarea matInput rows="4" [formControlName]="field.key"
              [placeholder]="'Enter ' + field.label"></textarea>

          </mat-form-field>
        </div>
        }
      </div>
    </div>
  </div>
</div>